
export interface SendMessageRequest {
  content: string;
  contentType?: string;
  /** @nullable */
  mediaUrl?: string | null;
  /** @nullable */
  replyToMessageId?: string | null;
}
